export const _environment = {
    api: {
        roaming: {
            apiPath: '/api/Roaming/',
            useHttps: 'true',
        },
        client: {
            apiPath: '/api/v3/service/',
        },
    },
    locale: {
        langLocales: {
            'en': 'en-GB',
            'en-us': 'en-US',
            'hu-hu': 'hu-HU',
            'en-gb': 'en-GB',
            'ru-ru': 'ru-RU',
            'ru': 'ru',
            'pl-pl': 'pl-PL',
            'pl': 'pl-PL',
            'es-es': 'es-ES',
            'es': 'es-ES',
            'si-lk': 'si-LK',
            'si': 'si-LK',
            'ta-lk': 'ta-LK',
            'ta': 'ta-LK',
        },
        fallbackLocale: 'en-US',
    },
};
